export default "__VITE_ASSET__CmXj$yBU__"